// components/ActionButtonsCell.jsx
import React from "react";
import ButtonTooltip from "./ButtonTooltip";

const ActionButtonsCell = ({ buttons = [] }) => {
  return (
    <ul
      className="list-unstyled hstack gap-1 mb-0 flex-wrap"
      style={{
        minWidth: "4rem",
        maxWidth: "4rem",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      }}
    >
      {buttons.map((btn, index) => (
        <li key={index}>
          {btn.component ? (
            // Allow custom component like ImageZipDownloader
            React.cloneElement(btn.component, btn.props || {})
          ) : (
            <ButtonTooltip
              type={btn.type}
              onClick={btn.onClick}
              btnId={btn.btnId}
              btnName={btn.btnName}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default ActionButtonsCell;
